// splitter
// layouts
import { useEffect, useState } from "react";
// @ts-ignore
import Cookies from 'js-cookie';
import { useMutation } from "@tanstack/react-query";
import { UserCharge } from "../../../../services/charge/userCharge";

const ErrorPaymentUser = () => {
    let [token, setToken] = useState();
    const mutation = useMutation({
        mutationFn: UserCharge,
        onSuccess: data => {
            setToken(data.token)
        },
        onError: (error) => {
            console.log(error)
        },
    });

    useEffect(() => {
        document.getElementById('site-main')?.classList.remove('main-content')
        document.getElementById('site-main')?.classList.add('bg-payment-new')
        document.getElementById('site-main')?.classList.add('bg-payment-new-home')
        document.getElementById('site-main')?.classList.add('bg-white')
        mutation.mutate(Cookies.get('mobileNumber'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        window.history.pushState(null, "", window.location.href);

        const handlePopState = (event: any) => {
            event.preventDefault();
            window.history.pushState(null, "", window.location.href);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);
    return (
        <>
            <article className={'payment h-100 overflow-x-hidden'}>
                <div className="row justify-content-center h-100">
                    <header className={'container text-center'}>
                        <div className="top-bar" style={{ paddingBottom: '15px' }}>
                            <div className="d-flex justify-content-center">
                                <img alt="logo" src={require('./../../../../assets/media/logo/Logo_Iran Tarakonesh_Vr_33_Sefid 1.webp')} className="img-fluid" />
                            </div>
                            <p className="text-white text-center mb-5 fw-bold">
                                سامانه ملی امن, سریع و آسان تراکنش ایران
                            </p>
                        </div>
                    </header>
                    <div className="col-md-6 col-lg-4">
                        <div id={'text-field'}>
                            <section style={{ marginTop: '-100px' }} className={'profile container'}>
                                <div className={'profile-items d-flex justify-content-center text-center'}>
                                    <img
                                        alt="profile"
                                        className="profile-img-valid"
                                        src={require('./../../../../assets/media/images/payment/Profile_Vr_01 1.png')} />

                                </div>
                                <p className={'fw-bold text-center mt-3 mb-1'}>
                                    {localStorage.getItem('name')}
                                </p>
                                <p className={'text-center mt-3 mb-1'}>
                                    {Cookies.get('mobileNumber')}
                                </p>
                            </section>
                            <section className={'bg-white text-center py-3 my-2'}>
                                <span className="badge bg-danger mt-2 py-2 fw-bold" style={{ fontSize: '18px' }}>
                                    به علت عدم پرداخت موفق ثبت نام شما کامل نشد
                                </span>
                            </section>
                            <div className={'d-flex justify-content-center mb-2 mt-2'}>
                                <button onClick={() => window.open(`https://sep.shaparak.ir/Onlinepg/sendtoken?token=${token}`, '_self')}
                                    className={'dark-green font-small mb-2 py-1 rounded-pill align-middle font-medium btn-site btn fw-bold'}>
                                    جهت پرداخت  هزینه سرویس ایران تراکنش اینجا کلیک کن
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </>
    )
}

export default ErrorPaymentUser;